document
  .querySelectorAll("[data-dropdown-toggle]")
  .forEach((dropdownSwitcher) =>
    dropdownSwitcher.addEventListener("click", toggleDropdown),
  );

function toggleDropdown(event) {
  const dropdownParent = event.currentTarget.closest("[data-dropdown]");
  if (dropdownParent) {
    dropdownParent.dataset.dropdown =
      dropdownParent.dataset.dropdown === "closed" ? "open" : "closed";
  }
}
